export enum CheckboxVariant {
  OPTION = 'option',
  IMAGE = 'image',
  CARD = 'card',
}

export enum AnswerButtonVariant {
  OPTION = 'option',
  IMAGE = 'image',
}

export enum ListLayoutVariant {
  COLUMN = 'column',
  ROW = 'row',
  TILE = 'tile',
  GRID = 'grid',
}
